module.exports = __webpack_public_path__ + "img/share-icon.a628e1bd.svg";